import React, { useState } from 'react'
import { Button, Input, Layout, theme } from 'antd'
import { Footer } from 'antd/es/layout/layout';
import { EnvironmentOutlined, MailOutlined, PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { createNewsletter } from '../redux/actions/newsletter';
import { message } from 'antd';
import { RootState } from '../redux/store';
import SocialButtons from '../components/SocialButtons';
import Navbar from '../components/Navbar';

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const { loading } = useSelector((state: RootState) => state.newsletter);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleSubscribe = async () => {
    if (!email) {
      message.error('Lütfen email adresinizi giriniz');
      return;
    }

    try {
      await dispatch(createNewsletter(email));
      setEmail('');
    } catch (err: any) {
      message.error(err.response.data.message);
    }
  };

  return (
    <>
      <Layout className='min-h-screen flex flex-col'>
        <Navbar />
        <SocialButtons />
        <main
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            paddingBottom: '20px',
          }}
          role="main"
          aria-label="Ana içerik"
        >
          {children}
        </main>
        <Footer className="bg-[#0d3b16] text-white">
          <div className="container mx-auto px-4 py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Hakkımızda */}
              <div>
                <h3 className="text-xl font-bold mb-4">Hakkımızda</h3>
                <p className="text-gray-300">
                  Sakarya Lastik olarak 20 yılı aşkın süredir iş makinesi ve kamyon lastikleri konusunda uzman hizmet sunuyoruz.
                </p>
              </div>

              {/* Hızlı Menü */}
              <div>
                <h3 className="text-xl font-bold mb-4">Hızlı Menü</h3>
                <ul className="space-y-2">
                  <li><a href="/hakkimizda" className="text-gray-300 hover:text-white">Hakkımızda</a></li>
                  <li><a href="/lastik" className="text-gray-300 hover:text-white">Lastikler</a></li>
                  <li><a href="/blog" className="text-gray-300 hover:text-white">Blog</a></li>
                  <li><a href="/iletisim" className="text-gray-300 hover:text-white">İletişim</a></li>
                </ul>
              </div>

              {/* İletişim */}
              <div>
                <h3 className="text-xl font-bold mb-4">İletişim</h3>
                <ul className="space-y-2 text-gray-300">
                  <li className="flex items-center gap-2">
                    <EnvironmentOutlined /> Adapazarı, Sakarya
                  </li>
                  <li className="flex items-center gap-2">
                    <a href="tel:05441205454" className="hover:text-gray-300 transition-colors"><PhoneOutlined /> 0(544) 120-54-54</a>
                  </li>
                  <li className="flex items-center gap-2">
                    <MailOutlined /> info@sakaryalastik.com
                  </li>
                </ul>
              </div>

              {/* Çalışma Saatleri */}
              <div>
                <h3 className="text-xl font-bold mb-4">Çalışma Saatleri</h3>
                <ul className="space-y-2 text-gray-300">
                  <li>Pazartesi - Cuma: 08:00 - 18:00</li>
                  <li>Cumartesi: 09:00 - 14:00</li>
                  <li>Pazar: Kapalı</li>
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className="mt-12 border-t border-[#135820] pt-8">
              <div className="max-w-md mx-auto">
                <h3 className="text-xl font-bold mb-4 text-center">Bültenimize Abone Olun</h3>
                <div className="flex gap-2">
                  <Input
                    placeholder="E-posta adresiniz"
                    className="flex-1"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    onPressEnter={handleSubscribe}
                    onBlur={handleSubscribe}
                    allowClear
                    type='email'
                    autoComplete='on'
                    aria-label="E-posta adresi"
                    id="newsletter-email"
                  />
                  <Button
                    type="primary"
                    className="bg-[#00861a] hover:bg-[#006d15]"
                    onClick={handleSubscribe}
                    loading={loading}
                    aria-label="Bültene abone ol"
                    title="Bültene abone ol"
                  >
                    Abone Ol
                  </Button>
                </div>
              </div>
            </div>

            {/* Copyright */}
            <div className="mt-8 text-center text-gray-400">
              <p>Sakarya Lastik ©{new Date().getFullYear()} Tüm hakları saklıdır.</p>
            </div>
          </div>
        </Footer>
        <div className="fixed bottom-0 left-0 right-0 flex w-full z-50 lg:hidden shadow-lg">
          <a href='tel:05441205454' className='w-1/2 flex flex-col justify-center items-center text-center bg-red-700 text-white py-2 px-1 hover:bg-red-800 transition-colors'>
            <span className='text-sm font-semibold flex items-center gap-1'>
              <PhoneOutlined className='text-base' /> Bizi Arayın
            </span>
            <span className='text-xs mt-0.5'>0544 120 5454</span>
          </a>
          <a href="https://wa.me/+905441205454" target='_blank' rel="noreferrer" className='w-1/2 flex flex-col justify-center items-center bg-green-700 text-white py-2 px-1 text-center hover:bg-green-800 transition-colors'>
            <span className='text-sm font-semibold flex items-center gap-1'>
              <WhatsAppOutlined className='text-base' /> WhatsApp
            </span>
            <span className='text-xs mt-0.5'>Bize Ulaşın</span>
          </a>
        </div>
      </Layout>
    </>
  )
}

export default MainLayout